<template>
  <div class="bell-notify__item" role="menuitem">
    <div class="stack">
      <div class="stack-left">
        <i class="icon md-info-outline" style="font-size: 14pt"></i>
      </div>
      <div class="stack-content" @click="showMessage">
        <h6 class="media-heading">{{ item.title }}</h6>
        <div class="media-body">
          {{ item.description }}
        </div>
        <time class="media-meta" datetime="">{{ item.created_at }}</time>
      </div>
      <div class="stack-right">
        <span v-if="!item.read_at">
          <span v-if="reading_error">
            <i class="fa fa-exclamation-triangle"
               aria-hidden="true"
               data-toggle="tooltip"
               data-placement="right"
               data-original-title="Ошибка!"/>
          </span>

          <span v-if="!reading_error && reading_loading">
            <i class="fa fa-spinner fa-pulse"
               aria-hidden="true"
               data-toggle="tooltip"
               data-placement="right"
               data-original-title="Загрузка..."/>
          </span>

          <span v-if="!reading_error && !reading_loading">
            <a @click.prevent="readMessage(item.id)" class="bell-notify__btn">
              <i id="bellCheck"
                 class="icon md-check"
                 data-toggle="tooltip"
                 data-placement="right"
                 data-original-title="Отметить одно сообщение прочитанным"/>
            </a>
          </span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name : 'NotificationBellMessage',
  props: [
    'item',
  ],
  data() {
    return {
      reading_loading: false,
      reading_error  : false,
    };
  },
  methods: {
    readMessage() {
      this.reading_loading = true;
      this.$emit('read', this.item.id);
    },
    showMessage() {
      Swal.fire({
        type             : 'info',
        title            : this.item.title,
        html             : '<br />' + this.item.message,
        confirmButtonText: 'Закрыть',
      }).then( (result) => {
        if(!this.item.read_at) {
          this.readMessage();
        }
      });
    }
  },
};
</script>

<style scoped>

.dropdown .fa {
  color: #636b6f;
  font-size: 11pt;
}

.bell-notify .nav-tabs {
  margin: 0;
}

.bell-notify .disabled {
  opacity: 0.5;
  pointer-events: none;
}

.bell-notify .nav-link {
  padding: 0.7rem 0.5rem !important;
  text-align: center;
}

.bell-notify__btn {
  opacity: 0.5;
  transition: opacity 0.5s;
  font-size: 14pt;
  color: #ff6611;
  cursor: pointer;
}

.bell-notify__btn:hover {
  opacity: 1;
}

.bell-notify .nav-item {
  flex-basis: 47% !important;
}

.bell-notify__heading {
  display: flex;
  align-items: center;
  padding: 0.5rem 1.4rem;
  border-bottom: 1px solid #e0e0e0;
}

.bell-notify__title {
  flex-grow: 1;
  color: #292521;
}

.stack-right i {
  font-size: 14pt
}

.stack {
  position: relative;
  display: flex;
  align-items: center;
  padding: 0.5rem 2rem;
  cursor: pointer;
  transition: background-color .5s
}

.stack--notice {
  background-color: #ebebeb;
  color: #8d8d8d;
  padding: 0.8rem 2rem;
  transition: color .3s;
}

.stack--notice:hover {
  color: #ff6611;
}

.stack:active {
  border-left: 3px #ff6611 solid;
}

.stack-content {
  margin: 0 0.5rem;
  flex-grow: 1;
}

.stack::before {
  content: '';
  position: absolute;
  bottom: 0px;
  height: 1px;
  width: 80%;
  background-color: #efefef;
}

.stack-left {
  align-self: flex-start;
  margin-top: 12px;
}

.stack:hover {
  background-color: #efefef;
}
</style>
